import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AnalysisService } from '@services/analysis/analysis.service';
import { ModuleAuth } from '@common_libraries/lib/ModuleAuth';
import { TRASecurityModule } from '@common_libraries/lib/Enums';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class AnalysisGuardService  {

  constructor(private analysisService: AnalysisService, private router: Router, private moduleAuth: ModuleAuth) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkAnalysisUser(route).toPromise()
      .then((e) => {
        return e;
      })
      .catch(() => {
        this.router.navigate(['/']);
        return false;
      });
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

  checkAnalysisUser(route: any): Observable<boolean> {
    return new Observable<boolean>(observer => {
      const analysisID = route.params['id'];

      if (analysisID === undefined) {
        // if no analysis id (Analysis View, Create New, etc) say they have access if they got past the module check
        observer.next(true);
        observer.complete();
      } else {
        // if there is an analysisID, check they have access to that analysis
        return this.analysisService.GetAnalysisByID(analysisID).subscribe((res: any) => {
            if (res.json.data != null) {
              observer.next(true);
              observer.complete();
            } else {
              this.router.navigate(['/analysis']);
              observer.next(false);
              observer.complete();
            }
          });
      }
    });
  }
}
